module.exports = __webpack_public_path__ + "img/twitter-logo.ba28c93.png";